import { CheckoutModal } from "components/CheckoutModal/CheckoutModal";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useQuery } from "hooks/useQuery";
import { useGetStateRegistrationsSummaryQuery } from "store/apis/StateRegistrations";
import { BillingInvoice } from "types/Models/billing";
import { useRegistrationCheckout } from "./useRegistrationCheckout";
import { SummaryCards, SummaryCardsSkeleton } from "./SummaryCards";

type NextDeadlineSectionProps = {
  onReviewDueFilings: () => void;
  onReviewOverdueFilings: () => void;
};

export const NextDeadlineSection = ({
  onReviewDueFilings,
  onReviewOverdueFilings,
}: NextDeadlineSectionProps) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const query = useQuery();
  const entityId = query.get("entity");

  const {
    invoice,
    checkoutModal,
    isForeignCA,
    closeCheckoutModal,
    onPaymentSuccess,
  } = useRegistrationCheckout();

  const { data: summary, isLoading } = useGetStateRegistrationsSummaryQuery(
    { groupId: groupId!, entityId: entityId! },
    { skip: !groupId || !entityId }
  );

  if (isLoading) {
    return <SummaryCardsSkeleton />;
  }

  if (!summary) {
    return null;
  }

  return (
    <>
      <SummaryCards
        summary={summary}
        onReviewDueFilings={onReviewDueFilings}
        onReviewOverdueFilings={onReviewOverdueFilings}
      />
      {checkoutModal.isOpen && Boolean(invoice) && (
        <CheckoutModal
          entityId={entityId!}
          type="invoices"
          onInvoicePaid={onPaymentSuccess}
          open={checkoutModal.isOpen}
          onClose={closeCheckoutModal}
          invoices={[invoice as BillingInvoice]}
          payerUserType={isForeignCA ? "FCA" : undefined}
        />
      )}
    </>
  );
};
